import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtonOutlined',
  props: {
  text: {
    type: String,
    default: '',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: '100%',
  },
  dataCy: {
    type: String,
    default: 'submit',
    required: false,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})